const extractMetadataIdFromUrl = (url: string): string | null => {
    const regex = /(\d{12})$/;

    const match = regex.exec(url);

    return match ? match[1] : null;
};

export default extractMetadataIdFromUrl;
